/**
 * @generated SignedSource<<4958bc4998a0750f1753d0251e2682cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AuditLogs_Query$variables = {
  id: string;
};
export type AuditLogs_Query$data = {
  readonly node: {
    readonly auditLog?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"useLogEntryFragment">;
      } | null>;
    };
  } | null;
};
export type AuditLogs_Query = {
  response: AuditLogs_Query$data;
  variables: AuditLogs_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  (v2/*: any*/),
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MemberAvatar",
    "kind": "LinkedField",
    "name": "avatar",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "roles",
    "storageKey": null
  }
],
v6 = [
  (v2/*: any*/)
],
v7 = [
  (v2/*: any*/),
  (v4/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Member",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v10 = [
  (v8/*: any*/),
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Member",
  "kind": "LinkedField",
  "name": "member",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v12 = [
  (v11/*: any*/)
],
v13 = [
  (v9/*: any*/)
],
v14 = [
  (v8/*: any*/)
],
v15 = [
  (v11/*: any*/),
  (v8/*: any*/)
],
v16 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MemberConnection",
    "kind": "LinkedField",
    "name": "members",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Member",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": (v5/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AuditLogs_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EventInterfaceConnection",
                "kind": "LinkedField",
                "name": "auditLog",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "useLogEntryFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "HasAuditLogInterface",
            "abstractKey": "__isHasAuditLogInterface"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AuditLogs_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EventInterfaceConnection",
                "kind": "LinkedField",
                "name": "auditLog",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isEventInterface"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "actor",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v5/*: any*/),
                            "type": "Member",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v6/*: any*/),
                            "type": "Node",
                            "abstractKey": "__isNode"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v6/*: any*/),
                            "type": "System",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DateTime",
                        "kind": "LinkedField",
                        "name": "datetime",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timestamp",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v10/*: any*/),
                        "type": "AuditLog__SpaceOwnerRemoved",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v12/*: any*/),
                        "type": "AuditLog__MemberCreated",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v12/*: any*/),
                        "type": "AuditLog__MemberDeleted",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v12/*: any*/),
                        "type": "AuditLog__MemberInvited",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v13/*: any*/),
                        "type": "AuditLog__TenantOwnerAdded",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v13/*: any*/),
                        "type": "AuditLog__TenantOwnerRemoved",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v14/*: any*/),
                        "type": "AuditLog__SpaceCreated",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v14/*: any*/),
                        "type": "AuditLog__SpaceDeleted",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v14/*: any*/),
                        "type": "AuditLog__SpacePropertiesUpdated",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v15/*: any*/),
                        "type": "AuditLog__SpaceMemberCreated",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v15/*: any*/),
                        "type": "AuditLog__SpaceMemberDeleted",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v14/*: any*/),
                        "type": "AuditLog__SpaceModuleCreated",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v14/*: any*/),
                        "type": "AuditLog__SpaceModuleDeleted",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v10/*: any*/),
                        "type": "AuditLog__SpaceOwnerAdded",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v16/*: any*/),
                        "type": "AuditLog__VaultManagerVaultCreated",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v16/*: any*/),
                        "type": "AuditLog__VaultManagerVaultMembersUpdated",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Member",
                            "kind": "LinkedField",
                            "name": "manager",
                            "plural": false,
                            "selections": (v5/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "AuditLog__VaultManagerVaultManagerAdded",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v14/*: any*/),
                        "type": "AuditLog__SpaceModulePermissionConfigUpdated",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v13/*: any*/),
                        "type": "AuditLog__FolderItemOwnerAdded",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v13/*: any*/),
                        "type": "AuditLog__FolderItemOwnerRemoved",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Folder",
                            "kind": "LinkedField",
                            "name": "destinationFolder",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "AuditLog__FolderItemMoved",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "change",
                            "storageKey": null
                          }
                        ],
                        "type": "AuditLog__FolderItemRuleChanged",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "HasAuditLogInterface",
            "abstractKey": "__isHasAuditLogInterface"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4a6c560fb27185827b7b7c612fddcdc1",
    "id": null,
    "metadata": {},
    "name": "AuditLogs_Query",
    "operationKind": "query",
    "text": "query AuditLogs_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on HasAuditLogInterface {\n      __isHasAuditLogInterface: __typename\n      auditLog {\n        nodes {\n          __typename\n          id\n          ...useLogEntryFragment\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment UserAvatar_member on Member {\n  name\n  email\n  avatar {\n    url\n  }\n}\n\nfragment UserHandle_member on Member {\n  id\n  name\n  email\n  ...UserAvatar_member\n  ...UserInfoPopover_member\n}\n\nfragment UserInfoPopover_member on Member {\n  id\n  name\n  email\n  roles\n  ...UserAvatar_member\n}\n\nfragment useLogEntryFragment on EventInterface {\n  __isEventInterface: __typename\n  __typename\n  id\n  actor {\n    __typename\n    ...UserHandle_member\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on System {\n      id\n    }\n  }\n  datetime {\n    timestamp\n  }\n  ... on AuditLog__ExportEvent {\n    __typename\n  }\n  ... on AuditLog__SpaceOwnerRemoved {\n    space {\n      id\n      name\n    }\n    owner {\n      ...UserHandle_member\n      id\n    }\n  }\n  ... on AuditLog__MemberCreated {\n    member {\n      ...UserHandle_member\n      id\n    }\n  }\n  ... on AuditLog__MemberDeleted {\n    member {\n      ...UserHandle_member\n      id\n    }\n  }\n  ... on AuditLog__MemberInvited {\n    member {\n      ...UserHandle_member\n      id\n    }\n  }\n  ... on AuditLog__MemberInvitationAccepted {\n    __typename\n  }\n  ... on AuditLog__TenantOwnerAdded {\n    owner {\n      ...UserHandle_member\n      id\n    }\n  }\n  ... on AuditLog__TenantOwnerRemoved {\n    owner {\n      ...UserHandle_member\n      id\n    }\n  }\n  ... on AuditLog__TenantPropertiesUpdated {\n    __typename\n  }\n  ... on AuditLog__TenantSpacesOrdered {\n    __typename\n  }\n  ... on AuditLog__SpaceCreated {\n    space {\n      id\n      name\n    }\n  }\n  ... on AuditLog__SpaceDeleted {\n    __typename\n    space {\n      id\n      name\n    }\n  }\n  ... on AuditLog__SpacePropertiesUpdated {\n    space {\n      id\n      name\n    }\n  }\n  ... on AuditLog__SpaceMemberCreated {\n    member {\n      ...UserHandle_member\n      id\n    }\n    space {\n      id\n      name\n    }\n  }\n  ... on AuditLog__SpaceMemberDeleted {\n    member {\n      ...UserHandle_member\n      id\n    }\n    space {\n      id\n      name\n    }\n  }\n  ... on AuditLog__SpaceModuleCreated {\n    space {\n      id\n      name\n    }\n  }\n  ... on AuditLog__SpaceModuleDeleted {\n    space {\n      id\n      name\n    }\n  }\n  ... on AuditLog__SpaceOwnerAdded {\n    space {\n      id\n      name\n    }\n    owner {\n      ...UserHandle_member\n      id\n    }\n  }\n  ... on AuditLog__VaultManagerVaultCreated {\n    members {\n      nodes {\n        id\n        ...UserHandle_member\n      }\n    }\n  }\n  ... on AuditLog__VaultManagerVaultMembersUpdated {\n    members {\n      nodes {\n        ...UserHandle_member\n        id\n      }\n    }\n  }\n  ... on AuditLog__VaultManagerVaultManagerAdded {\n    manager {\n      ...UserHandle_member\n      id\n    }\n  }\n  ... on AuditLog__SpaceModulePermissionConfigUpdated {\n    space {\n      id\n      name\n    }\n  }\n  ... on AuditLog__PublishedVaultItem {\n    __typename\n  }\n  ... on AuditLog__SignatureEnvelopeCreated {\n    __typename\n  }\n  ... on AuditLog__SignatureEnvelopeDeleted {\n    __typename\n  }\n  ... on AuditLog__SignatureEnvelopeSigned {\n    __typename\n  }\n  ... on AuditLog__PublishedFolderItem {\n    __typename\n  }\n  ... on AuditLog__FolderItemOwnerAdded {\n    __typename\n    owner {\n      ...UserHandle_member\n      id\n    }\n  }\n  ... on AuditLog__FolderItemOwnerRemoved {\n    __typename\n    owner {\n      ...UserHandle_member\n      id\n    }\n  }\n  ... on AuditLog__FolderItemMoved {\n    __typename\n    destinationFolder {\n      id\n      name\n    }\n  }\n  ... on AuditLog__FolderItemRuleChanged {\n    __typename\n    change\n  }\n}\n"
  }
};
})();

(node as any).hash = "1155edb8d248d85e837d6a58a22ff60b";

export default node;
